import type { OversightResultObligationByObligationIdResponseRow as OversightAssessmentObligationOversightResultsByObligationIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightAssessmentObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationOversightResultsByObligationIdArgs = {
  obligationId: string;
};

export const useGetObligationOversightResultsByObligationId = createQueryHook<
  UseGetObligationOversightResultsByObligationIdArgs,
  OversightAssessmentObligationOversightResultsByObligationIdResponseRow[],
  GetOversightAssessmentObligationAssessmentResultsByObligationIdQuery
>({
  trpcQueryOptions: (trpc, { obligationId }) =>
    trpc.frontend.assessment.oversightAssessmentObligationAssessmentResultsByObligationId.queryOptions(
      { obligationId }
    ),
  mapTrpcDataToGraphQL: (data) => ({
    obligation_oversight_result: data,
  }),
  graphqlDocument:
    GetOversightAssessmentObligationAssessmentResultsByObligationIdDocument,
  graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
});
